import React, {useState, useCallback} from 'react';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import Documented from 'components/help/Documented.js';
import {
    setParameterSliderDown,
    setParameterMidiMapSelection} from 'actions/index.js';
import {Knob, Arc, Pointer, Value} from 'components/rc-knob/index.js';
import {connect} from 'react-redux';

const ParameterKnob = ({
    unit,
    name,
    parameter,
    setParameterSliderDown,
    value,
    color,
    min=parameter.min,
    max=parameter.max,
    step,
    scrollContainer,
    isMidiSelected,
    midiMapMode,
    setParameterMidiMapSelection
}) => {
        let [initialSet, setInitialSet] = useState(false);
        let  useSqrt =  min >= 0;
        if (value < min) {
            value = min;
        }

        const onChange = useCallback((v) => {
            if (!initialSet) {
                setInitialSet(true);
                return;
            }
            document.activeElement.blur();
            let x = useSqrt ? Math.pow(v, 2) : v;
            if (x === min) {
                x = parameter.min;
            }
            parameter.set(x, false);

            if (midiMapMode === MAP) {
                setParameterMidiMapSelection(parameter.id);
            }
        }, [parameter, useSqrt, initialSet, setInitialSet, midiMapMode]);

        let v = useSqrt ? Math.sqrt(value) : value;
        let knob = (
            <Knob 
              scrollContainer={scrollContainer}
              size={30}  
              angleOffset={220} 
              angleRange={280}
              value={v}
              initialValue={v}
              step={step || 1}
              min={useSqrt ? Math.sqrt(min) : min}
              max={useSqrt ? Math.sqrt(max) : max}
              onChange={onChange}
            >
              <Arc 
                arcWidth={2}
                color={color || "white"}
                background="#6c757a"
              />
              <Pointer 
                width={2} 
                height={10}
                radius={4}
                type="rect"
                color={color || "white"}
              />
            </Knob>
        );

        const onMouseDown = useCallback((e) => {
            e.stopPropagation();
            setParameterSliderDown(parameter);
        }, [parameter]);

        const onMouseUp = useCallback(() => {
            setParameterSliderDown(undefined);
            parameter.automation.smoothen();
            parameter.mixAutomation.smoothen();
        }, [parameter]);

    let className = 'parameter-knob';
    if (isMidiSelected && midiMapMode === MAP) {
        className += ' midi-selected';
    }
    if (name) {
        return (
            <Documented
              element={parameter}
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              className={className}>
              {name}
              {knob}
              {Math.round(100*value)/100.0} {unit}
            </Documented>
        );
    } else {
        return (
            <Documented
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              className={className}>
              {knob}
                </Documented>
        );
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
        setParameterMidiMapSelection: parameterId => dispatch(setParameterMidiMapSelection(parameterId)),
    };
};
 
const mapStateToProps = (state, props) => {
    if (!props.parameter) {
        return {
            value: 0
        };
    }
    return {
        value: props.parameter.get(),
        isMidiSelected: props.parameter.id === state.midi.parameterSelected,
        midiMapMode: state.midi.midiMapMode
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterKnob);
